import { render, staticRenderFns } from "./AssignStockItemList.vue?vue&type=template&id=8b0ef9a6"
import script from "./AssignStockItemList.vue?vue&type=script&lang=js"
export * from "./AssignStockItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports